// extracted by mini-css-extract-plugin
export default {"buttom_project":"Button_buttom_project__npy6L","buttom_name":"Button_buttom_name__Nb41X"};